













































import { Component, Vue, Prop } from "vue-property-decorator";
import { Tijiaozhiyi, Zhiyijilu } from "@/request/sjzx";
import JiluRender from "./jilu-render.vue";
@Component({
  components: {
    JiluRender,
  },
})
export default class ZhiyiDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private zhenci: any;
  @Prop()
  private zhiyi: any;
  private jilus: any[] = [];
  private logs: any[] = [];
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  private cancel() {
    this.$emit("update:ifVisible", false);
  }
  /**
   * @description 获得质疑记录
   */
  private getZhiyijilu() {
    const params: any = {
      params: {
        zhenci_id: this.zhenci.zhenci_id,
      },
    };
    Zhiyijilu(this, params).then((data: any) => {
      data.forEach((item: any) => {
        item.ifShowDetail = true;
        item.action = "质疑";
      });
      this.jilus = data;
    });
  }
  /**
   * @description 添加质疑
   */
  private addZhiyi() {
    this.logs.push("");
  }
  /**
   * @description 删除一个记录
   */
  private deleteZhiyi(index) {
    this.logs.splice(index, 1);
  }
  /**
   * @description 提交质疑
   */
  private save() {
    const arr: any = [];
    this.logs.forEach((ele) => {
      if (ele) {
        arr.push(ele);
      }
    });
    if (arr.length === 0) {
      this.$message.warning("请填写质疑信息");
      return;
    }
    const params: any = {
      project_id: this.center.project_id,
      group_id: this.center.group_id,
      patient_id: this.zhenci.patient_id,
      zhenci_id: this.zhenci.zhenci_id,
      logs: arr,
    };
    if (this.zhenci.zhiyi_id) {
      params["zhiyi_id"] = this.zhenci.zhiyi_id;
    }
    Tijiaozhiyi(this, params).then((data: any) => {
      this.$message.success("提交成功");
      this.$emit("update:ifVisible", false);
      this.$emit("change");
    });
  }
  /**
   * @description 初始化，获得质疑记录
   */
  private mounted() {
    this.getZhiyijilu();
  }
}
